module.exports = __webpack_public_path__ + "static/media/account-group.804b1e73.png";